import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';

const LoadingPopup = ({ 
  isVisible = true,
  onClose = null
}) => {
  const [currentDot, setCurrentDot] = useState(0);

  useEffect(() => {
    if (!isVisible) return;
    
    const interval = setInterval(() => {
      setCurrentDot((prev) => (prev + 1) % 5);
    }, 200);

    return () => clearInterval(interval);
  }, [isVisible]);

  const DotsAnimation = () => (
    <div className="flex space-x-3">
      {[0, 1, 2, 3, 4].map((i) => (
        <div
          key={i}
          className={`w-3 h-3 rounded-full transition-all duration-300 ${
            currentDot === i 
              ? 'bg-blue-500 scale-125 shadow-lg shadow-blue-500/50' 
              : 'bg-gray-600 opacity-50'
          }`}
        />
      ))}
    </div>
  );

  if (!isVisible) return null;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Blurred backdrop */}
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" />
      
      {/* Loading popup */}
      <div className="relative bg-[#101012] backdrop-blur-xl flex justify-center items-center flex-col rounded-lg p-8 border border-gray-700/50">
        {/* Close button */}
        {onClose && (
          <button
            onClick={onClose}
            className="absolute top-2 right-2 text-gray-400 hover:text-white transition-colors"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        )}

        {/* Dots animation */}
        <DotsAnimation />
        <p className='text-white mt-3'>Loading...Please wait</p>

      </div>
    </div>,
    document.body
  );
};

export default LoadingPopup
